// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3Opp4","inputWrap":"styles_inputWrap__1Tjt2","input":"styles_input__2jH-D"};